import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub/';
import Brands from "./Brands";
import Categories from "./Categories";
import Specification from "./Specification";
import style from './style.scss'; //NOSONAR

let actions = [];

const Sidebar = (props) => {
    const [isFilterOpened, setIsFilterOpened] = useState(false);

    const onToogleFilter = (payload) => {
        setIsFilterOpened(payload.value.isFilterOpened || false);
    }

    const closeFilter = () => {
        setIsFilterOpened(false);
    }

    useEffect(() => {
        actions.push(PubSub.register('catalog_toogleFilter', onToogleFilter));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, [])
    
    const filters = props.filters ? props.filters : '';
    
    const categoriesObg = [{
        id: 0, 
        items: filters.categories, 
        name: "Categorias",
        url: "#"}];

    
    const specifications = props.specifications ? props.specifications : '';
    let categoriesCount = filters.categories ? filters.categories.length : '';
    const categoriesGroup = filters.categories && filters.categories.length < 2 ? filters.categories : categoriesObg;
    
    return(
        <div className="catalog-aside-wrapper">
            {filters && <div className={'catalog-aside' + (isFilterOpened ? " open" : "")}>
                <div className="catalog-aside-title"><i className="font-icn filter" />Filtrar</div>
                {filters.categories && filters.categories.length > 0 && categoriesGroup.map((category, i) => category.items && category.items.length > 0 ? <Categories category={category} categoriesCount={categoriesCount} key={i} /> : '')}
                <Brands brands={filters.brands} filter={props.filter}/>
                {specifications && specifications.length > 0 && specifications.map((specification) => {
                    return filters.filters && filters.filters[specification.Name] && filters.filters[specification.Name].length > 0 ? <Specification items={filters.filters[specification.Name]} title={specification.Name} id={specification.FieldId} key={specification.FieldId} filter={props.filter}/> : "";
                })}
            </div>}
            <span className={"catalog-aside-bg"+ (isFilterOpened ? " active" : "")} onClick={closeFilter}/>
        </div>
    )
}

Sidebar.propTypes = {
    filters: PropTypes.object,
    specifications: PropTypes.array,
    filter: PropTypes.object

};

export default Sidebar;
